import type { JSX } from "react";
const IconColour = (): JSX.Element => (
  <svg className="h-full" data-name="Livello 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <title>The Salon App icon</title>
    <defs>
      <style>
        {`
          .cls-1 {
            fill: #322f88;
          }

          .cls-2 {
            fill: #dc1079;
          }
        `}
      </style>
    </defs>
    <g>
      <path className="cls-1" d="M64,32a30.07,30.07,0,0,1-8.9,21.52A30.86,30.86,0,0,1,45.34,60a30.18,30.18,0,0,1-8,2.14V51.76a17.83,17.83,0,0,0,3.86-1.16,17.3,17.3,0,0,0,6-4.15A18.29,18.29,0,0,0,51,40.11,23.83,23.83,0,0,0,52.29,32,23.93,23.93,0,0,0,51,23.88a18.67,18.67,0,0,0-3.78-6.34,17.92,17.92,0,0,0-9.84-5.3V1.87a29.79,29.79,0,0,1,8,2.13A30.44,30.44,0,0,1,61.62,20.17,29.35,29.35,0,0,1,64,32"/>
      <path className="cls-1" d="M13.05,23.88A23.93,23.93,0,0,0,11.71,32a23.79,23.79,0,0,0,1.34,8.11,18.29,18.29,0,0,0,3.78,6.34,17.3,17.3,0,0,0,6,4.15,18.1,18.1,0,0,0,4,1.19V62.15A30.1,30.1,0,0,1,18.66,60,30.86,30.86,0,0,1,8.9,53.52,30,30,0,0,1,0,32,29.69,29.69,0,0,1,2.37,20.17,31.23,31.23,0,0,1,8.9,10.53,30.69,30.69,0,0,1,18.66,4a29.73,29.73,0,0,1,8.18-2.15V12.21a18.63,18.63,0,0,0-4,1.18,17.71,17.71,0,0,0-6,4.15,18.67,18.67,0,0,0-3.78,6.34"/>
      <polygon className="cls-2" points="32.06 32.46 37.04 32.57 26.7 47.09 31.84 32.61 27.09 32.51 37.45 17.28 32.06 32.46"/>
    </g>
  </svg>
);

export default IconColour;
